<template>
  <div class="panel panel-default panel-top-bordered">
    <div class="panel-body text-center">
      <div class="row" style="margin-bottom: 16px;">
        <div class="col-sm-12 text-left">
        Publication Date: {{ topic.attributes.publish_at | datetime }}
        </div>

        <div class="col-sm-4">
          <DateWidget v-model="filters.from"/>
        </div>

        <div class="col-sm-4">
          <DateWidget v-model="filters.to"/>
        </div>

        <div class="col-sm-4">
          <button class="btn btn-black btn-block" @click="load">
            Show
          </button>
        </div>
      </div>

      <div>
        <canvas ref="chart" width="800" height="250"/>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import moment from "moment";
import Chart from "chart.js";
import DateWidget from '@/vendor/forms/FormGroups/Widgets/Date'

export default {
  components: {DateWidget},

  props: {
    topic: {
      required: true,
    }
  },

  data() {
    return {
      data: null,

      filters: {
        from: moment(this.topic.attributes.publish_at).format('YYYY-MM-DD'),
        to: moment(this.topic.attributes.publish_at).add(30, 'days').format('YYYY-MM-DD'),
      },

      loading: true
    }
  },

  mounted() {
    this.load()
  },

  computed: {
    views() {
      return this.labels.map(label => this.data.find(row => row[this.interval < 60 ? 'date' : 'month'] === label)?.topic_render_count || 0)
    },

    labels() {
      let current = moment(this.filters.from)

      let result = []

      while (current.isBefore(this.filters.to)) {
        result.push(current.format(this.interval < 60 ? 'YYYY-MM-DD' : 'MM/YYYY'))

        current.add(1, this.interval < 60 ? 'day' : 'month')
      }

      return result
    },

    interval() {
      return moment(this.filters.to).diff(this.filters.from, 'days')
    }
  },

  methods: {
    load() {
      http.post('/api/v1/reports/new-analytics', {
        metrics: [
          {name: 'topic_render_count'},
        ],
        dimensions: [
          {name: this.interval < 60 ? 'date' : 'month'}
        ],
        filters: [
          {dimension: 'routable_id', operator: '=', value: this.topic.id},
          {dimension: 'date', operator: '>=', value: this.filters.from},
          {dimension: 'date', operator: '<=', value: this.filters.to}
        ]
      }).then(response => {
        this.data = response.data.data

        this.loading = false

        this.draw()
      })
    },

    draw() {
      if (this.chartData) {
        this.chartData.destroy()
      }

      this.$nextTick(() => {
        this.chartData = new Chart(this.$refs.chart, {
          type: 'bar',

          data: {
            labels: this.labels,

            datasets: [
              {
                label: 'Topic Page Views',
                data: this.views,
                backgroundColor: '#fd612c',
                borderColor: '#fd612c',
                color: '#fd612c',
              },
            ]
          },

          options: {
            maintainAspectRatio: false,

            scales: {
              xAxes: [{
                stacked: true
              }],
              yAxes: [{
                stacked: true,
                ticks: {
                  precision: 0,
                  beginAtZero: true
                }
              }]
            },

            plugins: {
              datalabels: {
                display: false
              }
            },
          }
        })
      })
    }
  }
}
</script>